import { render, staticRenderFns } from "./SvgCircle.vue?vue&type=template&id=8c101ff4&scoped=true"
import script from "./SvgCircle.vue?vue&type=script&lang=js"
export * from "./SvgCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c101ff4",
  null
  
)

export default component.exports